import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from 'recharts'

export default function PeakHoursChart({ hours, peakHour }) {
  if (!hours || hours.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-6">
        <h3 className="text-sm font-semibold text-slate-900 mb-4">Peak Hours</h3>
        <div className="flex items-center justify-center h-48 text-sm text-slate-400">
          No data for this period
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6">
      <h3 className="text-sm font-semibold text-slate-900 mb-4">Peak Hours</h3>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={hours} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 9, fill: '#94a3b8' }} interval={2} />
          <YAxis tick={{ fontSize: 11, fill: '#94a3b8' }} />
          <Tooltip
            contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12 }}
            formatter={(value) => [`${value} conversations`]}
          />
          <Bar dataKey="conversations" radius={[4, 4, 0, 0]}>
            {hours.map((entry) => (
              <Cell
                key={entry.hour}
                fill={entry.hour === peakHour ? '#2D6A4F' : '#94a3b8'}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
